import _classCallCheck from "C:\\Users\\Johan\\workspace\\resurrected\\common\\temp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\Johan\\workspace\\resurrected\\common\\temp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import { mat4, vec3 } from "gl-matrix";

var Transform =
/*#__PURE__*/
function () {
  function Transform() {
    _classCallCheck(this, Transform);

    this.queue = [];
  }

  _createClass(Transform, [{
    key: "queueMatrix",
    value: function queueMatrix(matrix) {
      var lastMatrix = this.queue[this.queue.length - 1];

      if (this.queue.length === 0 || !lastMatrix.matrix) {
        this.queue.push({
          matrix: matrix
        });
      } else {
        mat4.multiply(lastMatrix.matrix, matrix, lastMatrix.matrix);
      }

      return this;
    }
  }, {
    key: "queueOperation",
    value: function queueOperation(operation) {
      this.queue.push({
        operation: operation
      });
      return this;
    }
  }, {
    key: "queueFixedTranslation",
    value: function queueFixedTranslation(vectorOrX, optionalY, optionalZ) {
      var vector = this.internalMakeCanonicalVector(vectorOrX, optionalY, optionalZ);
      this.queueMatrix(mat4.fromTranslation(mat4.create(), vector));
      return this;
    }
  }, {
    key: "queueFixedScaling",
    value: function queueFixedScaling(vectorOrX, optionalY, optionalZ) {
      var vector = this.internalMakeCanonicalVector(vectorOrX, optionalY, optionalZ);
      this.queueMatrix(mat4.fromScaling(mat4.create(), vector));
      return this;
    }
  }, {
    key: "queueFixedXRotation",
    value: function queueFixedXRotation(radians) {
      this.queueMatrix(mat4.fromXRotation(mat4.create(), radians));
      return this;
    }
  }, {
    key: "queueFixedYRotation",
    value: function queueFixedYRotation(radians) {
      this.queueMatrix(mat4.fromYRotation(mat4.create(), radians));
      return this;
    }
  }, {
    key: "queueFixedZRotation",
    value: function queueFixedZRotation(radians) {
      this.queueMatrix(mat4.fromZRotation(mat4.create(), radians));
      return this;
    }
  }, {
    key: "queueFixedRotation",
    value: function queueFixedRotation(vectorOrX, optionalY, optionalZ, radians) {
      var vector = this.internalMakeCanonicalVector(vectorOrX, optionalY, optionalZ);
      this.queueMatrix(mat4.fromRotation(mat4.create(), radians, vector));
      return this;
    }
  }, {
    key: "queueContinuousMovement",
    value: function queueContinuousMovement(perMsVectorOrX, perMsOptionalY, perMsOptionalZ) {
      var vector = this.internalMakeCanonicalVector(perMsVectorOrX, perMsOptionalY, perMsOptionalZ);
      this.queueOperation(function (delta, sinceStart) {
        return mat4.fromTranslation(mat4.create(), vec3.scale(vec3.create(), vector, sinceStart));
      });
      return this;
    }
  }, {
    key: "queueContinuousGrowth",
    value: function queueContinuousGrowth(perMsVectorOrX, perMsOptionalY, perMsOptionalZ) {
      var vector = this.internalMakeCanonicalVector(perMsVectorOrX, perMsOptionalY, perMsOptionalZ);
      this.queueOperation(function (delta, sinceStart) {
        return mat4.fromScaling(mat4.create(), vec3.scale(vec3.create(), vector, sinceStart));
      });
      return this;
    }
  }, {
    key: "queueContinuousXRotation",
    value: function queueContinuousXRotation(perMsRadians) {
      this.queueOperation(function (delta, sinceStart) {
        return mat4.fromXRotation(mat4.create(), perMsRadians * sinceStart % (Math.PI * 2.0));
      });
      return this;
    }
  }, {
    key: "queueContinuousYRotation",
    value: function queueContinuousYRotation(perMsRadians) {
      this.queueOperation(function (delta, sinceStart) {
        return mat4.fromYRotation(mat4.create(), perMsRadians * sinceStart % (Math.PI * 2.0));
      });
      return this;
    }
  }, {
    key: "queueContinuousZRotation",
    value: function queueContinuousZRotation(perMsRadians) {
      this.queueOperation(function (delta, sinceStart) {
        return mat4.fromZRotation(mat4.create(), perMsRadians * sinceStart % (Math.PI * 2.0));
      });
      return this;
    }
  }, {
    key: "queueContinuousRotation",
    value: function queueContinuousRotation(vectorOrX, optionalY, optionalZ, perMsRadians) {
      var vector = this.internalMakeCanonicalVector(vectorOrX, optionalY, optionalZ);
      this.queueOperation(function (delta, sinceStart) {
        return mat4.fromRotation(mat4.create(), perMsRadians * sinceStart % (Math.PI * 2.0), vector);
      });
      return this;
    }
  }, {
    key: "queuePropertyTranslation",
    value: function queuePropertyTranslation(path) {
      var fetch = function fetch(pr) {
        return path.reduce(function (xs, x) {
          return xs && xs[x] ? xs[x] : null;
        }, pr);
      };

      this.queueOperation(function (delta, sinceStart, properties) {
        return mat4.fromTranslation(mat4.create(), fetch(properties));
      });
      return this;
    }
  }, {
    key: "queuePropertyScaling",
    value: function queuePropertyScaling(path) {
      var fetch = function fetch(pr) {
        return path.reduce(function (xs, x) {
          return xs && xs[x] ? xs[x] : null;
        }, pr);
      };

      this.queueOperation(function (delta, sinceStart, properties) {
        return mat4.fromScaling(mat4.create(), fetch(properties));
      });
      return this;
    }
  }, {
    key: "queuePropertyXRotation",
    value: function queuePropertyXRotation(path) {
      var fetch = function fetch(pr) {
        return path.reduce(function (xs, x) {
          return xs && xs[x] ? xs[x] : null;
        }, pr);
      };

      this.queueOperation(function (delta, sinceStart, properties) {
        return mat4.fromXRotation(mat4.create(), fetch(properties));
      });
      return this;
    }
  }, {
    key: "queuePropertyYRotation",
    value: function queuePropertyYRotation(path) {
      var fetch = function fetch(pr) {
        return path.reduce(function (xs, x) {
          return xs && xs[x] ? xs[x] : null;
        }, pr);
      };

      this.queueOperation(function (delta, sinceStart, properties) {
        return mat4.fromYRotation(mat4.create(), fetch(properties));
      });
      return this;
    }
  }, {
    key: "queuePropertyZRotation",
    value: function queuePropertyZRotation(path) {
      var fetch = function fetch(pr) {
        return path.reduce(function (xs, x) {
          return xs && xs[x] ? xs[x] : null;
        }, pr);
      };

      this.queueOperation(function (delta, sinceStart, properties) {
        return mat4.fromZRotation(mat4.create(), fetch(properties));
      });
      return this;
    }
  }, {
    key: "queuePropertyRotation",
    value: function queuePropertyRotation(vectorOrX, optionalY, optionalZ, path) {
      var fetch = function fetch(pr) {
        return path.reduce(function (xs, x) {
          return xs && xs[x] ? xs[x] : null;
        }, pr);
      };

      var vector = this.internalMakeCanonicalVector(vectorOrX, optionalY, optionalZ);
      this.queueOperation(function (delta, sinceStart, properties) {
        return mat4.fromRotation(mat4.create(), fetch(properties), vector);
      });
      return this;
    }
  }, {
    key: "queueOtherTransform",
    value: function queueOtherTransform(transform) {
      this.queue.push({
        transform: transform
      });
      return this;
    }
  }, {
    key: "internalMakeCanonicalVector",
    value: function internalMakeCanonicalVector(vectorOrX, optionalY, optionalZ) {
      if (optionalY !== undefined && optionalZ !== undefined) {
        return vec3.fromValues(vectorOrX, optionalY, optionalZ);
      } else {
        return vec3.fromValues(vectorOrX[0], vectorOrX[1], vectorOrX[2]);
      }
    }
  }, {
    key: "getMatrix",
    value: function getMatrix(timestampMs, properties) {
      if (this.queue.length === 1 && this.queue[0].matrix) {
        return this.queue[0].matrix;
      }

      var matrix = mat4.create();
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.queue[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          if (item.matrix) {
            mat4.multiply(matrix, item.matrix, matrix);
          } else if (item.transform) {
            mat4.multiply(matrix, item.transform.getMatrix(timestampMs, properties), matrix);
          } else {
            item.startTimestamp = item.startTimestamp || timestampMs;
            item.lastTimestamp = item.lastTimestamp || timestampMs;
            var sinceStart = timestampMs - item.startTimestamp;
            var delta = timestampMs - item.lastTimestamp;
            mat4.multiply(matrix, item.operation(delta, sinceStart, properties), matrix);
            item.lastTimestamp = timestampMs;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return matrix;
    }
  }]);

  return Transform;
}();

export { Transform as default };